<style src="./TopBar.scss" lang="scss" scoped></style>
<template>
  <section class="top-bar row between-all">
    <item-detail class="col-5" />
    <item-quoted class="col-7" />
  </section>
</template>

<script>
import ItemDetail from './item-detail/ItemDetail'
import ItemQuoted from './item-quoted/ItemQuoted'

export default {
  name: 'TopBar',
  components: {
    ItemDetail,
    ItemQuoted
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/components/top-bar/TopBar.vue